import type { Message } from "@ag-ui/client";

// The turn's new messages — the only ones the server needs on the wire. The
// database is the source of truth for history: the server rehydrates prior
// turns from it and appends what arrives here.
//
// A turn contributes exactly one of two shapes:
//   - a new user message (ordinary chat, including a follow-up typed under an
//     open card — the server closes that call from its own history), or
//   - the answers to the pause being answered now.
export function newOutboundMessages(
  messages: readonly Message[],
  pendingToolCallIds: ReadonlySet<string>
): Message[] {
  const last = messages.at(-1);
  if (!last) return [];
  if (last.role !== "tool") return last.role === "user" ? [last] : [];
  // The trailing run of tool messages is this pause's batch. Keeping only the
  // calls the server shows pending drops a result it produced itself (an
  // ordinary tool the model paired with the pausing one), which it would
  // otherwise refuse as an answer and fail the whole resume.
  let start = messages.length;
  while (start > 0 && messages[start - 1].role === "tool") start--;
  return messages
    .slice(start)
    .filter((msg) => msg.role === "tool" && pendingToolCallIds.has(msg.toolCallId));
}
